<style>
    #title {
      font-size: 3vw;
      font-weight: lighter;
      letter-spacing: 3vw;
    }
    #logo {
      min-width: 65px;
      max-width: 6vw;
      margin: 0 auto;
    }
    img {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
    .no-space {
      letter-spacing: 0;
    }
    @media only screen and (max-width: 576px) {
      #title {
      font-size: 10vw;
     
    }
}
  </style>
 <div class="container">
    <div class="row">
        <div class="col">
          <h1 id="title" class="text-center">
            FORZA <span class="no-space">4</span>
          </h1>
        </div>
      </div>
      <div id="logo" class="row">
        <div class="col">
            <img src="/assets/logo.svg" alt="" />
        </div>
      </div>
 </div>

